<template>
  <div class="footer-home clearfix">
      <!-- <h1 class="clearfix">
        <span class="fxl">关于我们</span>
        <div class="fxl margin20L font"><i class="fxl iconfont icon-weixin"></i> 官方微信</div>
        <div class="fxl margin40L font"><i class="fxl iconfont icon-weibo"></i> 官方微博</div>
      </h1> -->
      <h2 class="clearfix">
        <i class="fxl iconfont icon-dingwei"></i>
        <span class="fxl">
              医院地址：北京市丰台区右安门外大街199号
          </span>
      </h2>
      <h2 class="clearfix">
        <i class="fxl iconfont icon-dianhua"></i>
        <span class="fxl">
          服务热线：010-83322000; 83322548（咨询）; 83322619（投诉）; 15910941029（非工作时间）<br>
          工作时间：8:30—11:30，13:30—17:00
          </span>
      </h2>

      <h2 style="text-align: left;">京ICP备16033404号</h2>
  </div>
</template>

<script>

  export default {
    name: "Footer",
    props: {}
  };
</script>

<style lang="scss" scoped>
  .footer-home {
    color: #fff;
    padding: .3rem .2rem;
    background: -webkit-linear-gradient(90deg, #109c9e, #8bd8da); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(90deg, #109c9e, #8bd8da); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(90deg, #109c9e, #8bd8da); /* Firefox 3.6 - 15 */
    background: linear-gradient(90deg, #109c9e, #8bd8da); /* 标准的语法（必须放在最后） */
    h1 {
      font-size: .34rem;
      text-align: left;
      line-height:.8rem;
      border-bottom:1px solid #fff;
      margin-bottom: .2rem;
      font-weight: normal;
      i{
        font-size:.4rem;
        margin:.05rem .1rem 0rem;
      }
      .font{
        font-size: .3rem;
      }
    }

    h2 {
      font-size: .28rem;
      text-align: left;
      line-height: .5rem;
      padding:.1rem 0rem;
      font-weight:normal;

      i {
        font-size:.3rem;margin-right:.1rem;
      }
    }
  }

</style>
